import { render, staticRenderFns } from "./BlackHoleTab.vue?vue&type=template&id=eeb96510&scoped=true&"
import script from "./BlackHoleTab.vue?vue&type=script&lang=js&"
export * from "./BlackHoleTab.vue?vue&type=script&lang=js&"
import style0 from "./BlackHoleTab.vue?vue&type=style&index=0&id=eeb96510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb96510",
  null
  
)

export default component.exports